import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { usePermissions } from '../pages/shared/hooks/usePermissions';

/**
 * Demo mode banner component
 * Displays a prominent banner when user is in view-only/demo mode
 */
function DemoBanner() {
  const { isDemoViewer } = usePermissions();

  if (!isDemoViewer()) {
    return null;
  }

  return (
    <Alert
      severity="info"
      icon={<VisibilityIcon />}
      sx={{
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          👁️ Demo Mode - View Only Access
        </Typography>
        <Typography variant="caption" sx={{ display: 'block', mt: 0.5 }}>
          You are viewing this application in demo mode. All edit, create, and delete operations are disabled.
        </Typography>
      </Box>
    </Alert>
  );
}

export default DemoBanner;
